"use strict";

// this import is required because for some reason brunch will add a require for this,
// but that code is fairly limited in size, so whatever
import "process/browser.js";
import "js/editor/card_view.js";
import "js/editor/pdf_viewer.js";
import "js/controls/popup_follow_links.js";
const utilModule = require("js/util.js");
const alerts = require("js/alert.js");

const PARAM_RIGHT = "right";

const leftFrame = document.querySelector("#left-card");
const rightFrame = document.querySelector("#right-card");

const controlButtons = document.querySelector("#right-control-buttons");
const closeRightButton = document.querySelector("#close-component-btn");
const swapButton = document.querySelector("#swap-editor-btn");

const params = new URLSearchParams(window.location.search);
const rightUrl = params.get(PARAM_RIGHT);
console.log({ params, rightUrl, l: window.location.search, m: window.location });
if (rightUrl != null && decodeURIComponent(rightUrl) != "about:blank") {
    rightFrame.src = rightUrl;
    enableRightSide();
}

if (leftFrame && rightFrame) {
    [
        { thisFrame: leftFrame, otherFrame: rightFrame },
        { thisFrame: rightFrame, otherFrame: leftFrame },
    ].forEach(({ thisFrame, otherFrame }) => {
        thisFrame.addEventListener("load", (loadEvent) => {
            updateUrl(thisFrame);

            const cardViews = thisFrame.contentDocument.querySelectorAll("ldc-editor-card-view");
            cardViews.forEach((cardView) => cardView.renderResourcesStatic());

            // need to register these event listeners on each load event, because that will create
            // a new contentDocument
            registerOnClick(thisFrame, otherFrame);
            registerOnDblClick(thisFrame, otherFrame);
        });

        if (thisFrame == rightFrame) {
            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.type === "attributes" && mutation.attributeName === "src") {
                        enableRightSide();
                    }
                }
            });
            observer.observe(thisFrame, { attributes: true, childList: false, subtree: false });
        }
    });
}

if (closeRightButton) {
    closeRightButton.addEventListener("click", (event) => {
        disableRightSide();

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete(PARAM_RIGHT);
        window.history.replaceState({}, undefined, newUrl);
    });
}

if (swapButton) {
    swapButton.addEventListener("click", (event) => {
        const leftSrc = leftFrame.src;
        const rightSrc = rightFrame.src;

        const newUrl = new URL(rightSrc.replace(".embedded.", "."));
        newUrl.searchParams.set(PARAM_RIGHT, leftSrc);
        window.history.replaceState({}, undefined, newUrl);

        leftFrame.src = rightSrc;
        rightFrame.src = leftSrc;
    });
}

/*
 * We want to be able to reload a card with the current left and right cards, just like
 * in regular LDC. So we need to update the url on each card load of an iframe.
 *
 * The schema for the URL is rather simple: The current content of the left iframe
 * is the pathname, and the (possible) content of the right frame is a single
 * URL param.
 */
function updateUrl(thisFrame) {
    let newUrl;

    if (thisFrame == leftFrame) {
        newUrl = new URL(thisFrame.contentDocument.location.href.replace(".embedded.", "."));
        const right = new URL(window.location.href).searchParams.get(PARAM_RIGHT);

        if (right != null) {
            newUrl.searchParams.set(PARAM_RIGHT, right);
        }
    } else {
        newUrl = new URL(window.location.href);
        newUrl.searchParams.set(PARAM_RIGHT, thisFrame.contentDocument.location.href);
    }

    window.history.replaceState({}, undefined, newUrl);
}

function registerOnClick(thisFrame, otherFrame) {
    thisFrame.contentDocument.addEventListener(
        "click",
        (event) => {
            const frameToOpen = event.shiftKey ? otherFrame : thisFrame;

            if (event.target.matches("a") && event.shiftKey) {
                event.stopImmediatePropagation();
                event.preventDefault();

                otherFrame.src = event.target.href;

                return false;
            }

            // on ldc-link-content click => highlight the ldc-link-destination
            if (event.target.matches("ldc-link-content")) {
                // we assume the export function prepared a static url!
                let staticCardUrl = event.target.dataset.staticCardUrl;
                console.log("Clicked on ldc-link-content", event, staticCardUrl);

                if (staticCardUrl) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    frameToOpen.src = staticCardUrl;

                    const anchorId = event.target.dataset.anchorId;
                    setTimeout(() => {
                        utilModule
                            .waitForElements(() => {
                                const a = frameToOpen.contentWindow.document.getElementById(anchorId);
                                if (a) {
                                    return [a];
                                } else {
                                    return [];
                                }
                            }, 10)
                            .then((highlightedElements) => {
                                console.log(highlightedElements);
                                utilModule.highlightIfInViewPort(highlightedElements);
                            })
                            .catch((e) => {
                                console.log("Element not found!", e);
                            });
                    }, 300);
                    return false;
                }
            }

            // highlight the ldc-link-content
            if (event.target.matches("ldc-link-destination")) {
                console.log("Clicked on ldc-link-destination", event);

                let staticCardUrl = event.target.dataset.staticCardUrl;
                if (staticCardUrl) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    frameToOpen.src = staticCardUrl;

                    const anchorId = event.target.id;
                    setTimeout(() => {
                        utilModule
                            .waitForElements(() => {
                                let textAnchors = frameToOpen.contentWindow.document.querySelectorAll(
                                    `ldc-link-content[data-anchor-id='${anchorId}']`,
                                );
                                let anchorLinks = frameToOpen.contentWindow.document.querySelectorAll(
                                    `.anchor-link[data-anchor-id='${anchorId}']`,
                                );
                                return [...textAnchors].concat([...anchorLinks]);
                            }, 300)
                            .then((highlightedElements) => {
                                utilModule.highlightIfInViewPort(highlightedElements);
                            })
                            .catch((e) => {
                                console.log("Element not found!", e);
                            });
                    }, 300);

                    return false;
                }
            }
        },
        false,
    );
}

function handleTriangleClicks(clickedTarget, thisFrame, otherFrame, attributeInView) {
    console.log(clickedTarget);
    if (clickedTarget.matches(".loc-top-right") || clickedTarget.matches(".external-link")) {
        console.log("clicked on a link", clickedTarget, attributeInView);
        let link = attributeInView.querySelector(".external-link");
        const href = link.dataset.href;
        utilModule.openLink(href);
    }

    if (clickedTarget.matches(".loc-bottom-left") || clickedTarget.matches(".card-link")) {
        let link = attributeInView.querySelector(".card-link[data-static-url-accessible='true']");
        if (link) {
            console.log("Card link", link);
            const href = link.dataset.staticUrl;
            if (event.shiftKey) {
                otherFrame.src = href;
            } else {
                thisFrame.src = href;
            }
        }
        return false;
    }

    if (clickedTarget.matches(".loc-bottom-left") || clickedTarget.matches(".anchor-link")) {
        console.log("Anchor link clicked");
        let link = attributeInView.querySelector(".anchor-link");
        let anchorId = link.dataset.anchorId;

        utilModule
            .waitForElements(() => thisFrame.contentWindow.document.querySelectorAll(`#${CSS.escape(anchorId)}`), 10)
            .then((highlightedElements) => {
                console.log(highlightedElements);
                utilModule.highlightIfInViewPort(highlightedElements);
            })
            .catch(() => {
                alerts.danger(document, "Anchor text location not found.");
                console.log("Element not found!");
            });
    }

    if (clickedTarget.matches(".loc-top-left") || clickedTarget.matches(".pass-link")) {
        console.log("Pass link clicked");
        let link = attributeInView.querySelector(".pass-link");
        let href = link.dataset.staticPassedCardUrl;
        let objectId = link.dataset.singlePassedObjectId;

        const frame = event.shiftKey ? otherFrame : thisFrame;
        frame.src = href;

        // we need the timeout, because it takes some time for the frame to load
        setTimeout(() => {
            utilModule
                .waitForElements(
                    () => frame.contentDocument.querySelectorAll(`[data-id='${CSS.escape(objectId)}']`),
                    10,
                )
                .then((highlightedElements) => {
                    utilModule.highlightIfInViewPort(highlightedElements);
                })
                .catch((e) => {
                    console.log("Element not found!", e);
                });
        }, 200);
    }
}

function registerOnDblClick(thisFrame, otherFrame) {
    thisFrame.contentDocument.addEventListener("dblclick", (event) => {
        const attributeInView = utilModule.findParentWithSelector(event.target, ".view-card");

        if (attributeInView != null) {
            if (attributeInView.matches(".view-card[data-static-url-accessible='true']")) {
                event.stopImmediatePropagation();
                event.preventDefault;

                const href = attributeInView.dataset.staticUrl;

                if (event.shiftKey) {
                    otherFrame.src = href;
                } else {
                    thisFrame.src = href;
                }

                return false;
            } else if (attributeInView.matches(".link-in-view-card")) {
                const href = attributeInView.dataset.href;
                window.open(href, "_blank").focus();
            }

            event.stopImmediatePropagation();
            event.preventDefault();

            let triangles = attributeInView.querySelectorAll(".link-triangle");
            console.log(triangles);
            if (triangles.length == 1) {
                handleTriangleClicks(triangles[0], thisFrame, otherFrame, attributeInView);
            } else {
                handleTriangleClicks(event.target, thisFrame, otherFrame, attributeInView);
            }
        }
    });
}

function enableRightSide() {
    leftFrame.parentElement.classList.remove("col-span-2");
    rightFrame.parentElement.classList.remove("disabled");
    controlButtons.classList.remove("disabled");
}

function disableRightSide() {
    leftFrame.parentElement.classList.add("col-span-2");
    rightFrame.parentElement.classList.add("disabled");
    controlButtons.classList.add("disabled");
}
